import React from 'react';
import styled from 'styled-components';

const PatternWrapper = styled.div`
  position: ${props => props.$position || 'absolute'};
  top: ${props => props.$top || '0'};
  left: ${props => props.$left || '0'};
  width: ${props => props.$width || '100%'};
  height: ${props => props.$height || '100%'};
  z-index: ${props => props.$zIndex || '-1'};
  opacity: ${props => props.$opacity || '1'};
  pointer-events: none;
  background-image: url(${props => props.$patternUrl});
  background-repeat: repeat;
  background-size: ${props => props.$patternSize};
`;

export const CowPattern = ({ 
  patternUrl = '/assets/patterns/cow-pattern.svg',
  patternSize = '587.05px',
  position,
  top,
  left,
  width,
  height,
  zIndex,
  opacity = 0.1,
  className
}) => {
  return (
    <PatternWrapper
      $position={position}
      $top={top}
      $left={left}
      $width={width}
      $height={height}
      $zIndex={zIndex}
      $opacity={opacity}
      className={className}
      $patternUrl={patternUrl}
      $patternSize={patternSize}
    />
  );
};

// Preset for the page background
export const PageBackground = styled(CowPattern).attrs(props => ({
  patternUrl: '/assets/patterns/cow-pattern-background.svg',
  patternSize: '2800px', // 3x the original size
  opacity: 0.07,
  position: 'fixed'
}))`
  width: 100vw;
  height: 100vh;
  z-index: -1;
`;

// Preset for borders and smaller decorative uses
export const BorderPattern = styled(CowPattern).attrs(props => ({
  patternUrl: '/assets/patterns/cow-pattern-border.svg',
  patternSize: '117.41px', // 1/5 of the original size for borders
  opacity: 1,
  position: 'absolute'
}))`
  height: 64px;
`;

export default CowPattern; 